<template lang="pug">
    .settings-verification
        settings-page-head
        .settings-verification-wrapper
            head-of-settings-section.no-margin(title="Age Verification")
            .settings-section-head-wrapper(:class="{ 'no-margin': verified }")
                .profile-verification-status
                    .profile-verification-status-step(:class="{ 'active': !verified }") Get verified
                    .profile-verification-status-arrow
                        img(src="/images/client/got-me-hookd/right-arrow.svg" alt="")
                    .profile-verification-status-step(:class="{ 'active': verified }") Verified
            template(v-if="!verified")
                p(v-if="verifying") You haven't passed age verification. 
                    a(@click="verify") Try Again
                a.re-button.re-button--primary.re-button--sm(v-else @click="verify") Verify your age
            template(v-else)
                head-of-settings-section(title="Add Banking Details")
                .bank-details-wrapper
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="Business Name" v-model.trim="$v.fields.business_name.$model" :validations="validations.business_name" :v="$v.fields.business_name" @input="$v.fields.business_name.$reset")
                        .right-form-section
                            .re-inp-box
                                re-input(label="IBAN" v-model.trim="$v.fields.iban.$model" :validations="validations.iban" :v="$v.fields.iban" @input="$v.fields.iban.$reset")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="BIC (SWIFT)" v-model.trim="$v.fields.bic_swift.$model" :validations="validations.bic_swift" :v="$v.fields.bic_swift" @input="$v.fields.bic_swift.$reset")
                        .right-form-section
                            .re-inp-box
                                re-input(label="Name of your Bank" v-model.trim="$v.fields.bank_name.$model" :validations="validations.bank_name" :v="$v.fields.bank_name" @input="$v.fields.bank_name.$reset")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="Account Number" v-model.trim="$v.fields.number.$model" :validations="validations.number" :v="$v.fields.number" @input="$v.fields.number.$reset")
                        .right-form-section
                            .re-inp-box
                                re-input(label="Sort Code" v-model.trim="$v.fields.sort_code.$model" :validations="validations.sort_code" :v="$v.fields.sort_code" @input="$v.fields.sort_code.$reset")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-select(label="Country" v-model="$v.fields.country.$model" :validations="validations.country" :v="$v.fields.country" @input="$v.fields.country.$reset")
                                    option(value="")
                                    option(v-for="country in countries" :value="country.code") {{ country.name }}
                        .right-form-section
                            .re-inp-box
                                re-input(label="Address" v-model.trim="$v.fields.address.$model" :validations="validations.address" :v="$v.fields.address" @input="$v.fields.address.$reset")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="City" v-model.trim="$v.fields.city.$model" :validations="validations.city" :v="$v.fields.city" @input="$v.fields.city.$reset")
                        .right-form-section
                            .re-inp-box
                                re-input(label="Zip Code" v-model.trim="$v.fields.zip_code.$model" :validations="validations.zip_code" :v="$v.fields.zip_code" @input="$v.fields.zip_code.$reset")
                    .form-group-error(v-if="errorMessageProfile")
                        .error.invalid-feedback {{ errorMessageProfile }}
                    .settings-save-button
                        re-button.re-button--primary.re-button--sm(@click="submit" :loading="formSubmitting") Save

</template>

<script>
import ReProfileEdit from 'utils/vue/components/complex/profile/re-profile-edit/script.js'
import { Validators, parseValidations, parseValidationSetup, setValidationRule, zipRule } from 'utils/vue/lib/validations'
import { countries } from 'utils/vue/lib/utils'

const VALIDATIONS = {
    business_name: setValidationRule('fields.business_name', {
        required: { error: 'Business Name is required' }
    }),
    iban: setValidationRule('fields.iban', {
        required: { error: 'IBAN is required' },
        maxLength: { error: 'IBAN must be of maximum 34 digits', rule: Validators.maxLength(34) },
    }),
    bic_swift: setValidationRule('fields.bic_swift', {
        required: { error: 'BIC (SWIFT) is required' }
    }),
    sort_code: setValidationRule('fields.sort_code', {
        required: { error: 'Sort Code is required' },
        minLength: { error: 'Sort Code must be 6 digits', rule: Validators.minLength(6) },
        maxLength: { error: 'Sort Code must be 6 digits', rule: Validators.maxLength(6) },
    }),
    number: setValidationRule('fields.number', {
        required: { error: 'Account Number is required' }
    }),
    bank_name: setValidationRule('fields.bank_name', {
        required: { error: 'Name of your Bank is required' }
    }),
    country: setValidationRule('fields.country', {
        required: { error: 'Country is required' }
    }),
    address: setValidationRule('fields.address', {
        required: { error: 'Address is required' }
    }),
    city: setValidationRule('fields.city', {
        required: { error: 'City is required' }
    }),
    zip_code: setValidationRule('fields.zip_code', {
        required: { error: 'Zip Code is required' },
        zipRule: { error: 'Invalid Zip Code', rule: zipRule },
    }),
}

export default {
    name: 'settings-become-creator',

    mixins: [
        ReProfileEdit
    ],

    data() { return {
         fields: {
            business_name: '',
            iban: '',
            bic_swift: '',
            sort_code: '',
            number: '',
            bank_name: '',
            country: '',
            address: '',
            city: '',
            zip_code: '',
        },
        countries: countries.sort((a, b) => (a.name > b.name ? 1 : -1)),
    }},

    validations() {
        return { fields: parseValidations(VALIDATIONS) }
    },

    computed: {
        verified() {
            return this.$store.getters.authUser.meta.gmh_verified
        },
        verifying() {
            return this.$store.getters.authUser.meta.verification_reference
        },
    },

    methods: {
        async verify() {
            const { data: { verification_url: url } } = await axios.post('/api/customer/shufti-pro', {
                redirect: window.location.href,
            })
            window.location.href = url
        },

        setupFormLocal() {
            this.validations = parseValidationSetup(VALIDATIONS, this)
            this.setupForm(VALIDATIONS, {
                business_name: '',
                iban: '',
                bic_swift: '',
                sort_code: '',
                number: '',
                bank_name: '',
                country: '',
                address: '',
                city: '',
                zip_code: '',
            })
        },

        hydrateFields(fields) {
            const values = this.$store.getters.authUser.bank_account

            _.forOwn(this.fields, (item, key) => {
                if (!_.isNil(values[key])) {
                    this.fields[key] = values[key]
                }
            })
        },

        async submit() {
            this.isSuccessPersonal = null

            this.$v.$touch()

            if (!this.$v.$invalid) {
                const payload = {
                    bank_account: {
                        business_name: this.fields.business_name,
                        iban: this.fields.iban,
                        bic_swift: this.fields.bic_swift,
                        sort_code: this.fields.sort_code,
                        number: this.fields.number,
                        bank_name: this.fields.bank_name,
                        country: this.fields.country,
                        address: this.fields.address,
                        city: this.fields.city,
                        zip_code: this.fields.zip_code,
                    },
                }
    
                if (await this.changeProfile(payload)) {
                    this.isSuccessPersonal = true
                }
            }

        },
    }
}
</script>
